import { SalesOrderStatus } from './sales-order-status.js';
// Canonical terminal set: list-view default exclusion, field editability (COMPLETE_OR_LATER) and the worker's terminal-status guard.
export const TERMINAL_SALES_ORDER_STATUS_IDS = [
    SalesOrderStatus.COMPLETE,
    SalesOrderStatus.CANCELLED,
    SalesOrderStatus.REJECTED,
];
//# sourceMappingURL=sales-order-terminal-statuses.js.map